var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDeleteItem(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "delete-item",
    xmlns: "http://www.w3.org/2000/svg",
    width: 17.377,
    height: 18.824,
    viewBox: "0 0 17.377 18.824",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_37747",
    "data-name": "Path 37747",
    d: "M13.724,13a.723.723,0,0,0-.724.724v5.792a.724.724,0,1,0,1.448,0V13.724A.723.723,0,0,0,13.724,13Z",
    transform: "translate(-6.484 -5.76)",
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_37748",
    "data-name": "Path 37748",
    d: "M17.724,13a.723.723,0,0,0-.724.724v5.792a.724.724,0,1,0,1.448,0V13.724A.723.723,0,0,0,17.724,13Z",
    transform: "translate(-7.587 -5.76)",
    fill: "#fff"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_37749",
    "data-name": "Path 37749",
    d: "M14.861,3H10.516A1.45,1.45,0,0,0,9.068,4.448V5.9H4.724a.724.724,0,1,0,0,1.448H6.172V19.653a2.175,2.175,0,0,0,2.172,2.172h8.688A2.175,2.175,0,0,0,19.2,19.653V7.344h1.448a.724.724,0,1,0,0-1.448H16.309V4.448A1.45,1.45,0,0,0,14.861,3Zm2.9,16.653a.724.724,0,0,1-.724.724H8.344a.724.724,0,0,1-.724-.724V7.344H17.757ZM10.516,5.9V4.448h4.344V5.9Z",
    transform: "translate(-4 -3)",
    fill: "#fff"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteItem);
export default __webpack_public_path__ + "static/media/delete-item.e0662114.svg";
export { ForwardRef as ReactComponent };